import script from "./chart2.vue?vue&type=script&lang=ts&setup=true"
export * from "./chart2.vue?vue&type=script&lang=ts&setup=true"

import "./chart2.vue?vue&type=style&index=0&id=4f3f1b60&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f3f1b60"]])

export default __exports__